/**
 * Helpers de manipulation de texte cote front.
 *
 * Pourquoi ce module :
 * - Plusieurs champs venant de Salesforce sont stockes URL-encoded et
 *   contiennent du HTML embarque (e.g. `vanguardLabel`, `vanguardDescription`).
 * - Certains contextes UI veulent rendre ce HTML tel quel (mini-summary,
 *   panier, page produit), d'autres veulent du texte plat (cartes
 *   d'offres compactes ou la typo de la carte impose le rendu).
 * - On centralise ici la logique de decode + strip pour eviter la
 *   duplication entre composants (OrderSummary.vue, VanguardLabel.vue,
 *   VanguardDescription.vue).
 */

/**
 * Decode une chaine URL-encoded puis retire toutes les balises HTML et
 * decode les entites courantes (&nbsp;, &amp;, &lt;, &gt;, &#39;, &quot;).
 *
 * Retourne "" pour les entrees nullish / non-string, jamais null/undefined.
 *
 * @param {string} value chaine potentiellement URL-encoded avec HTML.
 * @returns {string} texte plat trimme.
 */
export function stripDecodedHtml(value) {
  if (!value || typeof value !== "string") return "";
  let decoded = value;
  try {
    decoded = decodeURIComponent(value);
  } catch (e) {
    // Chaine non-URI-valide (ex: contient des "%" libres) : on retombe sur
    // la valeur brute, on continue le strip HTML normalement.
    decoded = value;
  }
  return decoded
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
    .trim();
}

/**
 * Decode une chaine URL-encoded en preservant le HTML d'origine.
 * Utile pour les rendus via `v-html` (mini-summary, descriptions detaillees).
 *
 * Retourne "" pour les entrees nullish / non-string.
 *
 * @param {string} value chaine potentiellement URL-encoded.
 * @returns {string} HTML decode, trimme.
 */
export function decodeHtml(value) {
  if (!value || typeof value !== "string") return "";
  try {
    return decodeURIComponent(value).trim();
  } catch (e) {
    return value.trim();
  }
}
